module.exports = __webpack_public_path__ + "static/media/shape-5.490b7a19.webp";